import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'
import router from '@/router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import '@icon-park/vue-next/styles/index.css'
import 'animate.css'
import '@/assets/styles/prosemirror.scss'
import '@/assets/styles/global.scss'
import '@/assets/styles/tailwind.css' // 引入 Tailwind CSS
import '@/assets/styles/cssnormal.scss' // 引入 Tailwind CSS


import Icon from '@/plugins/icon'
import Directive from '@/plugins/directive'
import { bootstrapWechatSdk } from '@/utils/wechat'
// 区分环境，调试工具仅在非生产环境按需加载
// if (import.meta.env.MODE !== 'production') {
  // import('eruda').then(({ default: eruda }) => {
  //   eruda.init()
  // })
// }

bootstrapWechatSdk()

const store = createPinia()
store.use(piniaPluginPersistedstate)

const app = createApp(App)
app.use(Icon)
app.use(ElementPlus)
app.use(Directive)
app.use(store)
app.use(router)
app.mount('#app')

// 非关键字体样式延后加载，优先让首屏先渲染出来
const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
window.setTimeout(() => {
  void import('@/assets/styles/font.scss')
}, isMobileDevice ? 3000 : 800)
